import script from "./SellControlerTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SellControlerTable.vue?vue&type=script&setup=true&lang=js"

import "./SellControlerTable.vue?vue&type=style&index=0&id=8772900a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8772900a"]])

export default __exports__